module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJUlEQVQ4T2NgGBTgnKDaf3T856IYCmaYkoCJRw0YNWBwGTC0AQCE61j5kpUpiQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GN.png
// module id = 1151
// module chunks = 0